import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  Autocomplete,
  Chip,
} from "@mui/material";
import axios from "axios";
import "../App.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Profile from "./Profile";

const themeColors = {
  primary: "#90caf9",
  secondary: "#f48fb1",
  background: "#f0f0f0",
  textPrimary: "#444",
  textSecondary: "#888",
  hover: "#e3f2fd",
  selected: "#bbdefb",
};

function CurationStatus() {
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const navigate = useNavigate();
  const [feedDetails, setFeedDetails] = useState([]);
  const [datesChecked, setDatesChecked] = useState([]);
  const [viewMode, setViewMode] = useState("curation");
  const [frequency, setFrequency] = useState("daily");
  const [sources, setSources] = useState([]);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const inputRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [saveState, setSaveState] = useState(false)
  const data = feedDetails;
  const isoDate = new Date().toISOString().split('T')[0];
  const [year, month, day] = isoDate.split('-');
  const formattedDate = `${day}-${month}-${year}`;
  const [curationData, setCurationData] = useState({
    curation_name: "",
    frequency: "",
    no_of_files: { Arrived: "0", Expected: "0" },
    arrival_datetime: "",
    load_datetime: "",
    curation_date: new Date().toISOString().split('T')[0],
    curation_start_time: "",
    curation_end_time: "",
    time_taken: "",
    Last_Load_Datetime: "",
    Last_Curation_Datetime: "",
    dashboards_connected: "",
    snowflake_validation_status: "",
    snowflake_validated_by: "",
    acedo_validation_status: "",
    Descriptive_Analysis_Insights: "",
    validated_by: "",
  });
  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []);

  const [openDialog, setOpenDialog] = useState(false);
  const [showTopSave, setShowTopSave] = useState(true);
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollTop < 100) {
      setShowTopSave(true);
    } else if (scrollTop + windowHeight >= documentHeight - 100) {
      setShowTopSave(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      setCurationData({ ...data[0], ...{ curation_date: new Date().toISOString().split('T')[0] } });
    }
  }, [data]);

  useEffect(() => {
    if (datesChecked && frequency !== "Ad-Hoc") {
      setCurationData((prevState) => ({
        ...prevState,
        curation_date: datesChecked?.[0] || "",
      }));
    }
  }, [datesChecked,frequency]);

  useEffect(() => {
    if (Number(curationData?.no_of_files?.Arrived) > Number(curationData?.no_of_files?.Expected)) {
      setCurationData((prevData) => ({
        ...prevData,
        no_of_files: {
          ...prevData.no_of_files,
          Arrived: curationData?.no_of_files?.Expected
        }
      }));
    }
  }, [curationData])

  useEffect(() => {
    if (selectedFeed) {
      fetchFeedDetails(selectedFeed);
    }else{
      setCurationData([])
    }
    curationData.curation_date = frequency!=="Ad-Hoc" ?  (datesChecked?.[0] || formattedDate) : formattedDate
  }, [selectedFeed]);
  useEffect(() => {
    fetchSources();
  }, [frequency]);

  const fetchSources = async () => {
    try {
      const apiUrl = `/get-distinct-curation-names/?frequency=${frequency}`;
      const response = await axios.get(apiUrl);
      setSources(response.data);
    } catch (error) {
      console.error("Error fetching sources:", error);
    }
  };

  const fetchFeedDetails = async (feedName) => {
    try {
      const apiUrl = `/get-curation-details/?curation_name=${feedName}&frequency=${frequency}`;
      const response = await axios.get(apiUrl);
      setFeedDetails(response.data?.data);
      setDatesChecked(response?.data?.dates_checked)
      console.log(response.data, "data");
    } catch (error) {
      console.error("Error fetching feed details:", error);
    }
  };

  const showToast = () => {
    toast.promise(
      Promise.resolve(),
      {
        pending: "Loading...",
        success: "Data inserted successfully!",
      },
      {
        position: "top-right",
        autoClose: 5000,
      }
    );
  };
  const warnToast = (display_text) => {
    toast.warn(display_text, {
      position: "top-right",
      autoClose: 5000,
    });
  };

  const errorToast = () => {
    toast.promise(
      Promise.resolve(),
      {
        pending: "Loading...",
        error: "Error occurred while inserting data!",
      },
      {
        position: "top-right",
        autoClose: 5000,
      }
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // if (
    //   name === "Arrived" &&
    //   Number(value) > Number(curationData?.no_of_files?.Expected)
    // ) {
    //   const file_text = "Files Arrived cannot be higher than files Expected";
    //   warnToast(file_text);
    //   return;
    // }
    // if (
    //   name === "Expected" &&
    //   Number(value) < Number(curationData?.no_of_files?.Arrived)
    // ) {
    //   setCurationData((prevData) => ({
    //     ...prevData,
    //     no_of_files: {
    //       ...prevData.no_of_files,
    //       Arrived: curationData?.no_of_files?.Expected
    //     }
    //   }));
    //   return;
    // }
    if (name === "Arrived" || name === "Expected") {
      setCurationData((prevData) => ({
        ...prevData,
        no_of_files: {
          ...prevData.no_of_files,
          [name]: value,
        },
      }));
    } else {
      setCurationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveState(true)
    const requiredFields = [
      "arrival_datetime",
      "load_datetime",
      "curation_date",
      "curation_start_time",
      "curation_end_time",
      // "dashboards_connected",
      "acedo_validation_status",
      "Descriptive_Analysis_Insights",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!curationData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    curationData.Descriptive_Analysis_Insights = curationData.Descriptive_Analysis_Insights.trim();
    curationData.time_taken = calculateTimeTaken(
      curationData.curation_start_time,
      curationData.curation_end_time
    );
    console.log(feedDetails, "feed dsl");

    // setCurationData((prevData) => ({
    //   ...prevData,
    //   ...{validated_by:username}
    // }))
    console.log(curationData, "curation data");

    const dataToSubmit = [curationData].map((row) => ({
      ...row,
      validated_by: username,
    }));

    try {
      const headers = {
        "Content-Type": "application/json",
        "X-CSRFToken": cookies.csrftoken,
      };
      await axios.post("/insert-curation-details/", dataToSubmit, { headers });
      showToast();
      setTimeout(() => {
        navigate("/1");
        setSaveState(false)
      }, 2000);
      // setOpenDialog(true);
    } catch (error) {
      // errorToast();
      console.error("Error submitting curation data:", error);
    }
  };

  let mergedSelection = selectedFeed
    ? `${frequency.toUpperCase()} / ${selectedFeed}`
    : "";
  const handleFrequencyChange = (event) => {
    setFrequency(event.target.value);
    setCurationData({
      curation_name: "",
      frequency: "",
      no_of_files: { Arrived: "0", Expected: "0" },
      arrival_datetime: "",
      load_datetime: "",
      curation_date: new Date().toISOString().split('T')[0],
      curation_start_time: "",
      curation_end_time: "",
      time_taken: "",
      Last_Load_Datetime: "",
      Last_Curation_Datetime: "",
      dashboards_connected: "",
      snowflake_validation_status: "",
      snowflake_validated_by: "",
      acedo_validation_status: "",
      Descriptive_Analysis_Insights: "",
      validated_by: "",
    });
    setSelectedFeed();
  };

  const isFormValid = () => {


    return (
      (curationData.arrival_datetime &&
        curationData.load_datetime &&
        curationData.curation_date &&
        curationData.curation_start_time &&
        curationData.curation_end_time &&
        curationData.acedo_validation_status &&
        curationData.Descriptive_Analysis_Insights)
    );
  };
  const handleSourceChange = (event) => {
    const selected = event.target.value;
    setSelectedFeed(selected);
  };

  useEffect(() => {
    if (selectedFeed && inputRef.current) {
      inputRef.current.focus(); // Focus the input field
      inputRef.current.select(); // Select the input field's contents
    }
  }, [selectedFeed]);

  const calculateTimeTaken = (startTime, endTime) => {
    // Split the time strings into hours, minutes, and optional seconds
    const [startHours, startMinutes, startSeconds = 0] = startTime.split(":").map(Number);
    const [endHours, endMinutes, endSeconds = 0] = endTime.split(":").map(Number);

    // Convert the start and end times to total seconds since the start of the day
    const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
    const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

    let timeDifferenceInSeconds = endTotalSeconds - startTotalSeconds;

    if (timeDifferenceInSeconds < 0) {
      timeDifferenceInSeconds += 24 * 3600;
    }

    // Convert the difference back to hours and minutes
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    const minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const handleModeChange = (event) => {
    setViewMode(event.target.value);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/");
  };
  return (
    <div style={{ padding: '0px' }}>
      <Card
        elevation={0}
        sx={{
          p: "0.5rem",
          borderRadius: "12px",
          marginX: "1%",
        }}
      >
        <div id="frequency_selector" style={{ paddingRight: "10px" }}>
          <Grid
            container
            className="mb-2"
            alignItems="center"
            justifyContent="space-between "
            spacing={1}
          >
            <Grid item marginLeft={"0.7%"}>
              {mergedSelection ? (
                <Typography sx={{ textAlign: "center", fontWeight: "550" }}>
                  {mergedSelection}
                </Typography>
              ) : (
                <Typography sx={{ fontSize: "0.875rem", color: "red" }}>
                </Typography>
              )}
            </Grid>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Grid item>
                <ToggleButtonGroup
                  color="primary"
                  size="small"
                  value={frequency}
                  exclusive
                  onChange={handleFrequencyChange}
                  aria-label="frequency"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {["daily", "weekly", "monthly", 'Ad-Hoc'].map(
                    (freq) => (
                      <ToggleButton
                        key={freq}
                        value={freq}
                        sx={{
                          textTransform: "uppercase",
                          color: "#EAEAE",
                          fontWeight: "400",
                          "&.Mui-selected": {
                            color: "white",
                            fontWeight: "500",
                            backgroundColor: "#0073E6",
                            "&:hover": {
                              backgroundColor: "#0073E6",
                            },
                          },
                        }}
                      >
                        {freq}
                      </ToggleButton>
                    )
                  )}
                </ToggleButtonGroup>
              </Grid>

              <Grid item>
                <FormControl
                  variant="outlined"
                  sx={{ minWidth: 160, marginLeft: "8px" }}
                >
                  <Select
                    size="small"
                    value={selectedFeed || ""}
                    onChange={handleSourceChange}
                    displayEmpty
                  >
                    <MenuItem value="">Select Curation</MenuItem>
                    {sources.map((source) => (
                      <MenuItem key={source} value={source}>
                        {source.replaceAll("_", " ")}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        </div>
      </Card>
      <Box sx={{
        padding: "09px 16px 0 16px",
        borderRadius: "12px",
        // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        marginTop: "0px",
        marginX: "1%"
      }} noValidate autoComplete="off">
        <Grid container spacing={3} p={0} className="mb-1">
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* <Typography variant="h6">Add Curation</Typography> */}
            {/* {showTopSave && (
                  <Button
                    className="ms-2"
                    sx={{ padding: "7.5px 16px", backgroundColor: "#0576FC" }}
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!isFormValid()}
                  >
                    Save
                  </Button>
                )} */}
          </Grid>
        </Grid>
      </Box>

      <Card
        sx={{
          padding: "10px 10px ",
          borderRadius: "12px",
          // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",

          marginX: "1%"
        }}
        elevation={0}
      >

        <Card
          sx={{
            // border: "1px solid #eaeaea",
            borderRadius: "9px",
            // boxShadow:
            //   "rgba(149, 157, 165, 0.1) 0px 3px 6px 0px, rgba(149, 157, 165, 0.1) 0px -4px 6px 0px",
            padding: "10px 14px",
          }}
          elevation={0}
        >
          <Box

            noValidate
            autoComplete="off"
            sx={{ marginTop: "0rem" }}
          >
            <Grid container spacing={3} p={0}>
              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"space-between"}
              >
                <Typography sx={{ fontWeight: 400, color: 'rgb(0, 115, 230)' }}>Data Files</Typography>
              </Grid>
            </Grid>
          </Box>
          <Box noValidate autoComplete="off">
            <Grid container spacing={3} p={"20px 0px"}>
              <Grid item xs={12} sm={3}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Files Expected <span className="text-danger"> *</span>
                </Typography>
                <input
                  ref={inputRef}
                  className="form-control"
                  name="Expected"
                  type="number"
                  value={curationData?.no_of_files?.Expected || ""}
                  onChange={handleInputChange}
                  disabled={!selectedFeed}
                  onWheel={(e) => e.target.blur()}
                  min={0}
                />
              </Grid>

              <Grid item xs={12} sm={3} sx={{ paddingTop: "16px" }}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Files Arrived <span className="text-danger"> *</span>
                </Typography>
                <input
                  className="form-control"
                  type="number"
                  name="Arrived"
                  value={curationData?.no_of_files?.Arrived || ""}
                  onChange={handleInputChange}
                  disabled={!selectedFeed}
                  onWheel={(e) => e.target.blur()}
                  min={0}
                  max={curationData?.no_of_files?.Expected}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Arrival Date & Time <span className="text-danger"> *</span>
                </Typography>
                <input
                  className="form-control"
                  name="arrival_datetime"
                  value={curationData?.arrival_datetime || ""}
                  onChange={handleInputChange}
                  type="datetime-local"
                  disabled={!selectedFeed}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Load Date & Time <span className="text-danger"> *</span>
                </Typography>
                <input
                  className="form-control"
                  name="load_datetime"
                  value={curationData?.load_datetime || ""}
                  onChange={handleInputChange}
                  type="datetime-local"
                  disabled={!selectedFeed}
                />
              </Grid>
            </Grid>
          </Box>
        </Card>


        <ToastContainer />
        {/* </Card>
        <Card
          sx={{
            padding: "10px 10px ",
            // marginTop:"1rem",
            margin:"0rem 0 0 0",
            borderRadius: "12px",
            // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            // marginBottom:"30px",
            marginX:"3%"
          }}
          elevation={0}
        > */}


        <Card
          sx={{
            marginTop: "-1.3rem",
            // border: "1px solid #eaeaea",
            // boxShadow:
            //   "rgba(149, 157, 165, 0.1) 0px 4px 6px 0px, rgba(149, 157, 165, 0.1) 0px -2px 6px 0px",
            padding: "0px 14px",

          }}
          elevation={0}
        >
          <form action="" onSubmit={handleSubmit}>

            <Box noValidate autoComplete="off">
              <Grid container spacing={3} p={0}>
                <Grid item xs={12} display={"flex"} className="mt-3">
                  <Typography sx={{ fontWeight: 400, color: 'rgb(0, 115, 230)' }}>Curation</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box noValidate autoComplete="off">
              <Grid container spacing={2} p={"10px 0 0 0px"}>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    className="mb-1 "
                    variant="body2"
                    sx={{ fontWeight: "400" }}
                  >
                    Curation Date
                  </Typography>
                  {(frequency !== "Ad-Hoc" && datesChecked) ? (<>
                    <select
                      labelId="data-arrived-label"
                      className="form-control"
                      name="curation_date"
                      value={curationData.curation_date}
                      onChange={handleInputChange}
                      disabled={!selectedFeed}
                    >
                      <option value="">Select Curation date</option>
                      {Object.entries(datesChecked).map(([key, value], index) => (
                        <option key={index} value={value}>
                          {value}
                        </option>
                      ))}

                    </select>
                  </>) : (<input
                    className="form-control"
                    name="curation_date"
                    value={formattedDate}
                    onChange={handleInputChange}
                    // fullWidth
                    // size="small"
                    // variant="outlined"
                    // type="date"
                    // sx={{
                    //   "& .MuiOutlinedInput-root": {
                    //     "& fieldset": {
                    //       borderColor: "grey",
                    //     },
                    //     "&:hover fieldset": {
                    //       borderColor: "grey",
                    //     },
                    //     "&.Mui-focused fieldset": {
                    //       borderColor: "#86b7fe",
                    //     },
                    //   },
                    // }}
                    // inputProps={{
                    //   className: "form-control",
                    // }}
                    // error={!!errors?.curation_datetime}
                    // helperText={errors?.curation_datetime}
                    disabled={true}
                  />)}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    className="mb-1"
                    variant="body2"
                    sx={{ fontWeight: "400" }}
                  >
                    Curation Start Time <span className="text-danger">*</span>
                  </Typography>
                  <input
                    className="form-control"
                    name="curation_start_time"
                    value={curationData?.curation_start_time || ""}
                    onChange={handleInputChange}
                    type="time"
                    max={curationData?.curation_end_time}
                    // error={!!errors?.curation_start_time}
                    // helperText={errors?.curation_start_time}
                    disabled={!selectedFeed}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Typography
                    className="mb-1 "
                    variant="body2"
                    sx={{ fontWeight: "400" }}
                  >
                    Curation End Time <span className="text-danger"> *</span>
                  </Typography>
                  <input
                    name="curation_end_time"
                    className="form-control"
                    value={curationData?.curation_end_time || ""}
                    onChange={handleInputChange}
                    type="time"
                    min={curationData?.curation_start_time || ""}
                    disabled={!selectedFeed}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Typography
                    className="mb-1"
                    variant="body2"
                    sx={{ fontWeight: "400" }}
                  >
                    AceDO Validation Status <span className="text-danger"> *</span>
                  </Typography>
                  <select
                    className="form-control"
                    name="acedo_validation_status"
                    value={curationData?.acedo_validation_status || ""}
                    // displayEmpty
                    // size="small"
                    // sx={{ input: { color: "grey" } }}
                    // inputProps={{
                    //   className: "form-control",
                    // }}
                    onChange={handleInputChange}
                    disabled={!selectedFeed}
                  >
                    <option value="">Select Status</option>
                    <option value="yes">YES</option>
                    <option value="no">NO</option>
                  </select>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Dashboards Connected
                </Typography>

                <Autocomplete
                  multiple
                  size="small"
                  freeSolo
                  sx={{
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                    {
                      border: "0",
                    },
                  }}
                  readOnly
                  options={[]}
                  value={
                    curationData?.dashboards_connected
                      ? curationData?.dashboards_connected.split(",")
                      : ["N/A"]
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "dashboards_connected",
                        value: newValue.join(","),
                      },
                    });
                  }}
                  renderTags={(value, getTagProps) => {
                    const colors = [
                      "#0576FC",
                    ];

                    return value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={index}
                        label={option}
                        sx={{
                          backgroundColor: `${colors[index % colors.length]
                            }20`,
                          border: `1.7px solid ${colors[index % colors.length]
                            }`,
                          color: colors[index % colors.length],
                        }}
                      />
                    ));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      name="dashboards_connected"
                      size="small"
                      variant="outlined"
                      error={!!errors?.dashboards_connected}
                      helperText={errors?.dashboards_connected}
                    />
                  )}
                />
              </Grid>


              <Grid item xs={12} md={6}>
                <Typography
                  className="mb-1"
                  variant="body2"
                  sx={{ fontWeight: "400" }}
                >
                  Descriptive Analysis Insights <span className="text-danger"> *</span>
                </Typography>
                <textarea
                  className="form-control"
                  name="Descriptive_Analysis_Insights"
                  value={curationData?.Descriptive_Analysis_Insights || ""}
                  onChange={handleInputChange}
                  rows={2}
                  maxLength={250}
                  disabled={!selectedFeed}

                />

              </Grid>
              <Grid container display={"flex"} justifyContent={"end"}>
                <Grid item sx={{ padding: 0 }}>

                  <Button
                    className="ms-2 mt-0"
                    sx={{
                      padding: "7.5px 16px", backgroundColor: "#0576FC",
                      '&:disabled': {
                        backgroundColor: '#0576FC60',
                        color: '#FFFFFF'
                      }
                    }}
                    variant="contained"
                    type={"submit"}

                    // onClick={handleSubmit}
                    disabled={!isFormValid() || saveState}
                  >
                    Save
                  </Button>

                </Grid>
              </Grid>
            </Box>

          </form>
        </Card>

        <ToastContainer />
        {/* <Toaster
          toastOptions={{
            style: {
              fontSize: "20px",
              padding: "16px",
              width: "350px",
            },
          }}
        /> */}

      </Card>
    </div>
  );
}

export default CurationStatus;